import { render } from "./PrintView.vue?vue&type=template&id=0b5e12d9"
import script from "./PrintView.vue?vue&type=script&lang=js"
export * from "./PrintView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Work\\huabiao-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__